import React, {useContext, useState} from 'react';
import FamilyMemberCard from '../policyPage/FamilyMemberCard';
import { DigitalFuneralContext } from '../../context/DigitalFuneralContext';
import {OmApplicationButton} from '@om/component-library-react';
import RemoveMemberModalLanding from './RemoveMemberModalLanding';
import OmButton from '../../../../../../../components/forms/OmButton';
import './QuotePage.scss';


const LandingCoverMemberList = () => {

    const { coverMemberListLanding, toggleCoverDrawer, setRemoveId } = useContext(DigitalFuneralContext);

    const [isOpen, setIsOpen] = useState(false);

    const getTotalPremium = () => {
        let _total = 0
        coverMemberListLanding.map(p => {
            _total += parseFloat(p.coverAmtPremium)
        })
        return _total.toFixed(2);
    };

    const buyNowCTA = () => {
        window.location.href = '/ekyire-asem'
    }

    const removeHandler = (id) => {
        setRemoveId(id);
        setIsOpen(true);
    };
    
    return (
        <div style={{width:'50%', margin: 'auto'}} className='ekyire-asem-main'>
            
            {coverMemberListLanding.map(member => 
                <FamilyMemberCard
                    key={member?.id} 
                    member={member?.id}
                    hasDetails={false}
                    canRemove={true}
                    description={member?.relationship}
                    age={member.age}
                    coverAmount={member?.coverAmt}
                    monthlyPremium={member?.coverAmtPremium}
                    editCoverMemberHandler={null}
                    removeMemberHandler={()=> removeHandler(member?.id)}
                />
            )}

            {coverMemberListLanding.length > 0 && coverMemberListLanding.length < 3 ?
                <div style={{textAlign: 'center', marginBottom: '15px !important', marginTop: '20px'}}>
                    <p style={{marginBottom: '10px !important'}}>Would you like to cover more people?</p>
                    <OmApplicationButton
                        text="ADD COVER"
                        iconName="add"
                        onButtonClicked={() => toggleCoverDrawer()}
                    />
                </div>
                : ''}

            <div>
                <div className='quote-wrapper'>
                    <div className='quote-header'>
                        <div style={{display: 'flex', justifyContent: 'space-around'}}>
                            <div>
                                <h5 style={{paddingTop: '7px'}}>QUOTE SUMMARY</h5>
                            </div>
                            <div>
                                <h4><strong>₵{getTotalPremium()} p/m</strong></h4>
                            </div>
                        </div>
                    </div>
                    <hr style={{width:'100%'}}/>
                    <div style={{display: 'flex', justifyContent: 'space-around', padding: '5px'}}>
                        <div>
                            <p>Are you ready to purchase your funeral cover?</p>
                        </div>
                        <div className='quote-summary-right'>
                            <OmButton
                                text="APPLY NOW"
                                iconName="arrow_forward"
                                slot="right"
                                onClick={() => buyNowCTA()}
                                type="primary"
                                size="small"
                            />
                        </div>
                    </div>
                </div>
            </div>
            
            {isOpen ? <RemoveMemberModalLanding /> : ''}
        </div>
    )
}

export default LandingCoverMemberList;